module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m2m-schedule-page"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Расписание приема поручений M2M")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loader"
  }) : [_c('section', {
    staticClass: "schedule-section"
  }, [_c('h2', [_vm._v("Базовое расписание")]), _vm._v(" "), _c('p', {
    staticClass: "section-description"
  }, [_vm._v("\n        Понедельник–пятница считаются рабочими днями, суббота и воскресенье — выходными.\n        Указанное время применяется по Москве.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "schedule-fields"
  }, [_c('b-field', {
    attrs: {
      "label": "Начало приема"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "time",
      "step": "60"
    },
    model: {
      value: (_vm.schedule.startTime),
      callback: function($$v) {
        _vm.$set(_vm.schedule, "startTime", $$v)
      },
      expression: "schedule.startTime"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Окончание приема"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "time",
      "step": "60"
    },
    model: {
      value: (_vm.schedule.endTime),
      callback: function($$v) {
        _vm.$set(_vm.schedule, "endTime", $$v)
      },
      expression: "schedule.endTime"
    }
  })], 1), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('button', {
    staticClass: "button is-info",
    attrs: {
      "disabled": _vm.savingSchedule
    },
    on: {
      "click": _vm.saveSchedule
    }
  }, [_vm._v("\n        " + _vm._s(_vm.savingSchedule ? 'Сохранение...' : 'Сохранить расписание') + "\n      ")])]), _vm._v(" "), _c('section', {
    staticClass: "schedule-section"
  }, [_c('h2', [_vm._v("Добавить исключение")]), _vm._v(" "), _c('p', {
    staticClass: "section-description"
  }, [_vm._v("\n        Исключение имеет приоритет над базовым расписанием и действует только в выбранную дату.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "exception-form"
  }, [_c('b-field', {
    attrs: {
      "label": "Дата"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "placeholder": "Выберите дату"
    },
    model: {
      value: (_vm.newException.date),
      callback: function($$v) {
        _vm.$set(_vm.newException, "date", $$v)
      },
      expression: "newException.date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "day-type-field"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Тип исключения")]), _vm._v(" "), _c('b-radio-group', {
    staticClass: "day-type-options",
    model: {
      value: (_vm.newException.isWorking),
      callback: function($$v) {
        _vm.$set(_vm.newException, "isWorking", $$v)
      },
      expression: "newException.isWorking"
    }
  }, [_c('b-radio-button', {
    attrs: {
      "value": false,
      "type": "is-info"
    }
  }, [_vm._v("Нерабочий день")]), _vm._v(" "), _c('b-radio-button', {
    attrs: {
      "value": true,
      "type": "is-info"
    }
  }, [_vm._v("Рабочий день")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "switch-field"
  }, [_c('b-switch', {
    model: {
      value: (_vm.newException.useCustomTime),
      callback: function($$v) {
        _vm.$set(_vm.newException, "useCustomTime", $$v)
      },
      expression: "newException.useCustomTime"
    }
  }, [_vm._v("\n            Использовать индивидуальные часы\n          ")]), _vm._v(" "), (!_vm.newException.useCustomTime) ? _c('p', {
    staticClass: "field-hint"
  }, [(_vm.newException.isWorking) ? [_vm._v("\n              Действует базовое расписание:\n              " + _vm._s(_vm.schedule.startTime) + "–" + _vm._s(_vm.schedule.endTime) + ".\n            ")] : [_vm._v("\n              Прием будет закрыт на весь день.\n            ")]], 2) : _vm._e()], 1), _vm._v(" "), (_vm.newException.useCustomTime) ? _c('div', {
    staticClass: "custom-time-fields"
  }, [_c('b-field', {
    attrs: {
      "label": "Начало"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "time",
      "step": "60"
    },
    model: {
      value: (_vm.newException.startTime),
      callback: function($$v) {
        _vm.$set(_vm.newException, "startTime", $$v)
      },
      expression: "newException.startTime"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Окончание"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "time",
      "step": "60"
    },
    model: {
      value: (_vm.newException.endTime),
      callback: function($$v) {
        _vm.$set(_vm.newException, "endTime", $$v)
      },
      expression: "newException.endTime"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Комментарий"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Например, праздничный или перенесенный рабочий день"
    },
    model: {
      value: (_vm.newException.comment),
      callback: function($$v) {
        _vm.$set(_vm.newException, "comment", $$v)
      },
      expression: "newException.comment"
    }
  })], 1)], 1), _vm._v(" "), _c('button', {
    staticClass: "button is-info add-exception-button",
    attrs: {
      "disabled": _vm.savingNewException
    },
    on: {
      "click": _vm.createException
    }
  }, [_vm._v("\n        " + _vm._s(_vm.savingNewException ? 'Добавление...' : 'Добавить исключение') + "\n      ")])]), _vm._v(" "), _c('section', {
    staticClass: "schedule-section exceptions-section"
  }, [_c('h2', [_vm._v("Календарные исключения")]), _vm._v(" "), _c('div', {
    staticClass: "exceptions-filter"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Тип исключения")]), _vm._v(" "), _c('b-radio-group', {
    staticClass: "day-type-options",
    model: {
      value: (_vm.exceptionTypeFilter),
      callback: function($$v) {
        _vm.exceptionTypeFilter = $$v
      },
      expression: "exceptionTypeFilter"
    }
  }, [_c('b-radio-button', {
    attrs: {
      "value": "all",
      "type": "is-info"
    }
  }, [_vm._v("Все")]), _vm._v(" "), _c('b-radio-button', {
    attrs: {
      "value": "nonWorking",
      "type": "is-info"
    }
  }, [_vm._v("Нерабочие дни")]), _vm._v(" "), _c('b-radio-button', {
    attrs: {
      "value": "working",
      "type": "is-info"
    }
  }, [_vm._v("Рабочие дни")])], 1)], 1), _vm._v(" "), (!_vm.exceptions.length) ? _c('p', {
    staticClass: "empty-message"
  }, [_vm._v("Исключений пока нет.")]) : (!_vm.filteredExceptions.length) ? _c('p', {
    staticClass: "empty-message"
  }, [_vm._v("\n        Исключений выбранного типа нет.\n      ")]) : _c('div', {
    staticClass: "table-wrapper"
  }, [_c('table', {
    staticClass: "table is-fullwidth exceptions-table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredExceptions), function(exception) {
    return _c('tr', {
      key: exception.id
    }, [_c('td', [_vm._v(_vm._s(_vm.formatDate(exception.date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(exception.isWorking ? 'Рабочий день' : 'Нерабочий день'))]), _vm._v(" "), _c('td', {
      staticClass: "time-column"
    }, [_vm._v(_vm._s(_vm.formatExceptionHours(exception)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(exception.comment || '—'))]), _vm._v(" "), _c('td', {
      staticClass: "actions-column"
    }, [_c('button', {
      staticClass: "icon-button",
      attrs: {
        "title": "Редактировать исключение"
      },
      on: {
        "click": function($event) {
          return _vm.openEditException(exception)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/img/icons/edit.svg",
        "alt": "Редактировать"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "icon-button",
      attrs: {
        "title": "Удалить исключение"
      },
      on: {
        "click": function($event) {
          return _vm.confirmDeleteException(exception)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/img/icons/delete.svg",
        "alt": "Удалить"
      }
    })])])])
  }), 0)])])]), _vm._v(" "), (_vm.editingException) ? _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.closeEditException
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card exception-modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Редактировать исключение")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "Закрыть",
      "title": "Закрыть"
    },
    on: {
      "click": _vm.closeEditException
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('b-field', {
    attrs: {
      "label": "Дата"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "placeholder": "Выберите дату"
    },
    model: {
      value: (_vm.editingException.date),
      callback: function($$v) {
        _vm.$set(_vm.editingException, "date", $$v)
      },
      expression: "editingException.date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "day-type-field"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Тип исключения")]), _vm._v(" "), _c('b-radio-group', {
    staticClass: "day-type-options",
    model: {
      value: (_vm.editingException.isWorking),
      callback: function($$v) {
        _vm.$set(_vm.editingException, "isWorking", $$v)
      },
      expression: "editingException.isWorking"
    }
  }, [_c('b-radio-button', {
    attrs: {
      "value": false,
      "type": "is-info"
    }
  }, [_vm._v("Нерабочий день")]), _vm._v(" "), _c('b-radio-button', {
    attrs: {
      "value": true,
      "type": "is-info"
    }
  }, [_vm._v("Рабочий день")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "switch-field"
  }, [_c('b-switch', {
    model: {
      value: (_vm.editingException.useCustomTime),
      callback: function($$v) {
        _vm.$set(_vm.editingException, "useCustomTime", $$v)
      },
      expression: "editingException.useCustomTime"
    }
  }, [_vm._v("\n              Использовать индивидуальные часы\n            ")]), _vm._v(" "), (!_vm.editingException.useCustomTime) ? _c('p', {
    staticClass: "field-hint"
  }, [(_vm.editingException.isWorking) ? [_vm._v("\n                Действует базовое расписание:\n                " + _vm._s(_vm.schedule.startTime) + "–" + _vm._s(_vm.schedule.endTime) + ".\n              ")] : [_vm._v("\n                Прием будет закрыт на весь день.\n              ")]], 2) : _vm._e()], 1), _vm._v(" "), (_vm.editingException.useCustomTime) ? _c('div', {
    staticClass: "custom-time-fields"
  }, [_c('b-field', {
    attrs: {
      "label": "Начало"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "time",
      "step": "60"
    },
    model: {
      value: (_vm.editingException.startTime),
      callback: function($$v) {
        _vm.$set(_vm.editingException, "startTime", $$v)
      },
      expression: "editingException.startTime"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Окончание"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "time",
      "step": "60"
    },
    model: {
      value: (_vm.editingException.endTime),
      callback: function($$v) {
        _vm.$set(_vm.editingException, "endTime", $$v)
      },
      expression: "editingException.endTime"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Комментарий"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Например, праздничный или перенесенный рабочий день"
    },
    model: {
      value: (_vm.editingException.comment),
      callback: function($$v) {
        _vm.$set(_vm.editingException, "comment", $$v)
      },
      expression: "editingException.comment"
    }
  })], 1)], 1), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.savingException
    },
    on: {
      "click": _vm.closeEditException
    }
  }, [_vm._v("\n            Отмена\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button is-info",
    attrs: {
      "disabled": _vm.savingException
    },
    on: {
      "click": _vm.updateException
    }
  }, [_vm._v("\n            " + _vm._s(_vm.savingException ? 'Сохранение...' : 'Сохранить') + "\n          ")])])])]) : _vm._e()]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timezone-field"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Часовой пояс")]), _vm._v(" "), _c('span', {
    staticClass: "timezone-value"
  }, [_vm._v("Москва (Europe/Moscow)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Дата")]), _vm._v(" "), _c('th', [_vm._v("Тип")]), _vm._v(" "), _c('th', [_vm._v("Время")]), _vm._v(" "), _c('th', [_vm._v("Комментарий")]), _vm._v(" "), _c('th', {
    staticClass: "actions-column"
  }, [_vm._v("Действия")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dc85fe0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/M2MSchedule/Index.vue
// module id = 973
// module chunks = 0